import { createI18n } from 'vue-i18n';
import { loadLocalEnglishMessages } from '@/i18n/catalog';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: loadLocalEnglishMessages(),
  },
});

export default i18n;
